import Alpine from "alpinejs";
import Splide from "@splidejs/splide";

document.addEventListener("alpine:init", () => {
  Alpine.data("services_OurSolutions", () => ({
    init() {
      const slider = new Splide(this.$refs.splide, {
        perPage: 1,
        gap: 40,
        type: "fade",
        loop: true,
        pagination: false,
        mediaQuery: "min",
      });
      slider.mount();
    },
  }));
});
